import { styled } from 'baseui';
export const BaseLi = styled('li', props => ({
  listStylePosition: 'outside',
  padding: 0,
  margin: '0 0 0 24px',
  ...props.$theme.typography.font200
}));